export type LabelWrapperProps = {
  label?: string;
  className?: string;
  children?: never;
};

/**
 * Thin `<span>` wrapper that can be used to apply padding to a text for vertical (and horizontal) alignment.
 * Mirrors the LabelWrapper component found throughout the Figma design system, keeping a 1-to-1 mapping between
 * Figma layers and code.
 */
export function LabelWrapper({ label, className }: LabelWrapperProps) {
  return (
    <span data-slot="label-wrapper" className={className}>
      {label}
    </span>
  );
}
